import {
  GENERAL_SETTINGS_REQUEST_ASYNC,
  UPDATE_GENERAL_SETTINGS_REQUEST,
  UPDATE_PASSWORD_REQUEST,
} from './constants'

const getGeneralSettings = () => ({
  type: GENERAL_SETTINGS_REQUEST_ASYNC.INITIATE,
})
export const getGeneralSettingsSuccess = (data) => ({
  type: GENERAL_SETTINGS_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const getGeneralSettingsError = (error) => ({
  type: GENERAL_SETTINGS_REQUEST_ASYNC.ERROR,
  error,
})
const getGeneralSettingsCancel = () => ({
  type: GENERAL_SETTINGS_REQUEST_ASYNC.CANCEL,
})

const updateGeneralSettings = () => ({
  type: UPDATE_GENERAL_SETTINGS_REQUEST.INITIATE,
})
export const updateGeneralSettingsSuccess = (data) => ({
  type: UPDATE_GENERAL_SETTINGS_REQUEST.SUCCESS,
  payload: { data },
})
export const updateGeneralSettingsError = (error) => ({
  type: UPDATE_GENERAL_SETTINGS_REQUEST.ERROR,
  error,
})
const updateGeneralSettingsCancel = () => ({
  type: UPDATE_GENERAL_SETTINGS_REQUEST.CANCEL,
})

const updPassword = () => ({ type: UPDATE_PASSWORD_REQUEST.INITIATE })
export const updPasswordSuccess = (values) => ({
  type: UPDATE_PASSWORD_REQUEST.SUCCESS,
  payload: { values },
})
export const updPasswordError = (error) => ({
  type: UPDATE_PASSWORD_REQUEST.ERROR,
  error,
})
const updPasswordCancel = () => ({ type: UPDATE_PASSWORD_REQUEST.CANCEL })

export default {
  // to props
  getGeneralSettings,
  getGeneralSettingsCancel,
  updateGeneralSettings,
  updateGeneralSettingsCancel,
  updPassword,
  updPasswordCancel,
}
